import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=3662bafd&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=3662bafd&scoped=true&lang=css&"
import style1 from "./todo.vue?vue&type=style&index=1&id=3662bafd&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662bafd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3662bafd')) {
      api.createRecord('3662bafd', component.options)
    } else {
      api.reload('3662bafd', component.options)
    }
    module.hot.accept("./todo.vue?vue&type=template&id=3662bafd&scoped=true&", function () {
      api.rerender('3662bafd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/recommend/components/todo.vue"
export default component.exports